export const sharedColors = {
  darkGreyText: '#050505',
  lightGreyText: '#606770',
  dividerLine: '#dddfe2',
}
